export default __webpack_public_path__ + "static/media/004.68c48c99.png";